import { useState, useEffect } from "react";
import { RadioGroup } from "@headlessui/react";

import { useTranslation } from "react-i18next";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}


function PetAlergic({ petInfo, setPetInfo, setIsComplete, petType }) {
  const isAlergicOption = [{ hasAlergic: true }, { hasAlergic: false }];
  const [hasAlergic, setHasAlergic] = useState();
  const [alergies, setAlergies] = useState(petInfo.allergies);
  const [hasHealthIssues, setHasHealthIssues] = useState();
  const [activator, setActivator] = useState(false);

  // const alergieList = [
  //   { id: 1, name: "Tavuk Eti", value: "chicken" },
  //   { id: 2, name: "Hindi Eti", value: "turkey" },
  //   { id: 3, name: "Dana Eti", value: "calf" },
  //   { id: 4, name: "Kuzu Eti", value: "lamb" },
  //   { id: 5, name: "Diğer...", value: "other" },
  // ];

  const { t } = useTranslation();

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        hasAlergic: hasAlergic?.hasAlergic,
      });
    }
  }, [hasAlergic]);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        hasHealthIssues: hasHealthIssues?.hasAlergic,
      });
    }
  }, [hasHealthIssues]);

  // useEffect(() => {
  //   setActivator(true);
  //   if (activator) {
  //     setPetInfo({
  //       ...petInfo,
  //       allergies: alergies,
  //     });
  //   }
  // }, [alergies]);

  useEffect(() => {
    (petInfo.hasAlergic
      ? Object.keys(petInfo.allergies).length > 0
      : petInfo.hasAlergic !== "") && petInfo.hasHealthIssues !== ""
      ? setIsComplete(true)
      : setIsComplete(false);
  }, [petInfo]);

  return (
    <div className="w-11/12 max-w-lg flex flex-col text-left pt-12">
      <div className="relative">
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <h2 className="font-medium font-poppins text-lg text-yellow-600 text-left">
              {petType == 'dog' ? t("petHasAllergy") : t("catPetHasAllergy")}
            </h2>
          </div>

          <RadioGroup
            value={hasAlergic}
            onChange={setHasAlergic}
            className="mt-2"
          >
            <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
              {isAlergicOption.map((option,index) => (
                <RadioGroup.Option
                  key={`${option.neutral}_${index}`}
                  value={option}
                  className={({ active, checked }) =>
                    classNames(
                      "cursor-pointer focus:outline-none",

                      active ? "ring-2 ring-offset-2 ring-lime-500" : "",
                      checked || petInfo.hasAlergic === option.hasAlergic
                        ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                        : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50",
                      "border rounded-md py-3 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
                    )
                  }
                >
                  <RadioGroup.Label as="span">
                    {option.hasAlergic ? t("allergyYes") : t("allergyNo")}
                  </RadioGroup.Label>
                </RadioGroup.Option>
              ))}
            </div>
          </RadioGroup>
        </div>
      </div>
      {petInfo.hasAlergic && (
          // <div>
          //   <fieldset>
          //     <div className="flex flex-wrap justify-center items-center  sm:flex-nowrap sm:justify-center ">
          //       {alergieList.map((alergie, key) => (
          //         <div
          //           key={key}
          //           className="relative flex items-center justify-center py-4 px-4 sm:py-4 sm:px-4"
          //         >
          //           <div className="min-w-0  text-sm">
          //             <label
          //               htmlFor={`alergie-${alergie.id}`}
          //               className="font-medium text-yellow-700 select-none"
          //             >
          //               {alergie.name}
          //             </label>
          //           </div>
          //           <div className="ml-3 flex items-center h-5">
          //             <input
          //               onChange={(e) => {
          //                 setAlergies(
          //                   e.target.checked &&
          //                     !alergies.includes(alergie.value)
          //                     ? [...alergies, alergie.value]
          //                     : alergies.filter(
          //                         (item) => item !== alergie.value
          //                       )
          //                 );
          //               }}
          //               id={`alergie-${alergie.id}`}
          //               name={`alergie-${alergie.id}`}
          //               checked={petInfo.allergies.includes(alergie.value)}
          //               type="checkbox"
          //               className="focus:ring-lime-500 h-4 w-4 text-lime-600 border-gray-300 rounded"
          //             />
          //           </div>
          //         </div>
          //       ))}
          //     </div>
          //   </fieldset>
          // </div>
          <div className="relative justify-center items-center flex-col mb-8">
            <div className="relative max-w-xs  mr-auto mb-4 group  sm:max-w-md">
              <input
                onChange={(e) => {
                  setPetInfo({ ...petInfo, allergies: e.target.value });
                }}
                type="alergies"
                name="alergies_pet"
                className="block py-2.5 px-0 w-full text-lg text-yellow-600 bg-transparent border-0 border-b-2 border-yellow-400 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-lime-500 focus:outline-none focus:ring-0 focus:border-lime-600 peer"
                placeholder=" "
                required={true}
                value={petInfo.allergies}
              />
              <label
                htmlFor="alergies_pet"
                className="peer-focus:font-medium absolute left-0 text-sm text-yellow-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-600 peer-focus:dark:text-lime-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                {t("enterAllergy")}
              </label>
            </div>
            <div className="max-w-xs sm:max-w-md mr-auto ">
              <div className=" text-yellow-600 text-left text-xs">
                {t("contactUsAllergy")}
              </div>
            </div>
          </div>
        )}
      <div className="relative flex-col justify-center items-center">
        <div className="mb-6 sm:mt-6">
          <div className="flex items-center justify-between">
            <h2 className="font-medium font-poppins text-lg text-yellow-600 text-left">
              {petType == 'dog' ? t("petHasDisease") : t("catPetHasDisease")}
            </h2>
          </div>

          <RadioGroup
            value={hasHealthIssues}
            onChange={setHasHealthIssues}
            className="mt-2"
          >
            <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
              {isAlergicOption.map((option, index) => (
                <RadioGroup.Option
                  key={`${option.hasAlergic}_${index}`}
                  value={option}
                  className={({ active, checked }) =>
                    classNames(
                      "cursor-pointer focus:outline-none",

                      active ? "ring-2 ring-offset-2 ring-lime-500" : "",
                      checked || petInfo.hasHealthIssues === option.hasAlergic
                        ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                        : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50",
                      "border rounded-md py-3 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
                    )
                  }
                >
                  <RadioGroup.Label as="span">
                    {option.hasAlergic ? t("diseaseYes") : t("diseaseNo")}
                  </RadioGroup.Label>
                </RadioGroup.Option>
              ))}
            </div>
          </RadioGroup>
        </div>
        
      </div>
      {petInfo.hasHealthIssues && (
          <div className="justify-center items-center flex-col mb-8">
            <div className="relative max-w-xs  mr-auto group  sm:max-w-md">
              <input
                onChange={(e) => {
                  setPetInfo({ ...petInfo, disease: e.target.value });
                }}
                type="alergies"
                name="alergies_pet"
                className="block py-2.5 px-0 w-full text-lg text-yellow-600 bg-transparent border-0 border-b-2 border-yellow-400 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-lime-500 focus:outline-none focus:ring-0 focus:border-lime-600 peer"
                placeholder=" "
                required={true}
                value={petInfo.disease}
              />
              <label
                htmlFor="alergies_pet"
                className="peer-focus:font-medium absolute left-0 text-sm text-yellow-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-600 peer-focus:dark:text-lime-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                {t("enterDisease")}
              </label>
            </div>
            <div className="max-w-xs sm:max-w-md mr-auto ">
              <div className=" text-yellow-600 text-left text-xs">
                {t("contactUsDisease")}
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default PetAlergic;
